import PropTypes from 'prop-types';
import React from 'react';
import { Question } from './Question';

export class DropdownQuestion extends React.Component {
  onChange = (event) => {
    if (this.textBox) {
      this.textBox.value = '';
    }

    this.props.updateAnswer(
      this.props.questionnaireItem.questionnaireItemId,
      {
        listAnswerId: parseInt(event.target.value, 10),
        otherOptionText: '',
      });

    if (this.props.questionnaireItem.isValid === false) {
      this.props.validateQuestionnaire();
    }
  }

  getClassName() {
    if (this.textBox) {
      const answer =
      this.props.questionnaireItem.listAnswers
        .find(la => la.listAnswerId === parseInt(this.dropDown.value, 10));
      return answer.isOtherTextValid === false ?
        'form-group col-xs-12 col-sm-4 has-error' : 'form-group col-xs-12 col-sm-4';
    }
    return 'form-group col-xs-12 col-sm-4';
  }

  textOnBlur = (event) => {
    this.props.updateAnswer(
      this.props.questionnaireItem.questionnaireItemId,
      {
        listAnswerId: parseInt(this.dropDown.value, 10),
        otherOptionText: event.target.value,
      });

    if (this.props.questionnaireItem.isValid === false) {
      this.props.validateQuestionnaire();
    }
  }

  isShowTextBox() {
    return this.props.disabled ? this.isShowTextBoxDisabled() : this.isShowTextBoxNormal();
  }

  isShowTextBoxNormal() {
    if (this.dropDown === undefined) {
      return false;
    }

    const selectedAnswer =
      this.props.questionnaireItem.listAnswers
        .find(answer => answer.listAnswerId.toString() === this.dropDown.value);
    return selectedAnswer ? selectedAnswer.isOtherOption : false;
  }

  isShowTextBoxDisabled() {
    if (this.props.answerItem) {
      const selectedAnswer =
      this.props.questionnaireItem.listAnswers
        .find(answer => answer.listAnswerId === this.props.answerItem.listAnswerId);
      return selectedAnswer ? selectedAnswer.isOtherOption : false;
    }
    return false;
  }

  render() {
    const { questionnaireItem, answerItem } = this.props;
    const opts = {};
    const selectOpts = {};
    opts.disabled = this.props.disabled;
    selectOpts.disabled = this.props.disabled;
    if (this.isShowTextBoxDisabled) {
      if (answerItem) {
        opts.value = answerItem.otherOptionText;
      }
    }
    if (this.props.answerItem) {
      selectOpts.value = answerItem.listAnswerId;
    }

    return (
      <div className="form-group question-area" data-qa-item="dropdown_question_type">
        <Question questionNumber={questionnaireItem.questionNumber}
          isValid={ questionnaireItem.isValid }
          formattedText={questionnaireItem.formattedText}
          isRequired={questionnaireItem.isRequired}
        />
        <div className="row questionnaire-control">
          <div className="form-group col-xs-12 col-sm-4">
            <select className="form-control"
              ref={ (dropdown) => { this.dropDown = dropdown; } }
              onChange={this.onChange}
              {...selectOpts}
            >
              <option></option>
              {this.props.questionnaireItem.listAnswers.map(answer =>
              (<option key={answer.listAnswerId} value={answer.listAnswerId}>
                {answer.formattedText}
               </option>))}
            </select>
          </div>
          {this.is}
          { this.isShowTextBox() ?
            <div className={ this.getClassName() }>
              <input type="text"
                ref={ (textbox) => { this.textBox = textbox; } }
                className="form-control" onBlur={this.textOnBlur} maxLength="2000" {...opts}
              />
            </div> : null }
        </div>
      </div>
    );
  }
}

DropdownQuestion.propTypes = {
  questionnaireItem: PropTypes.object,
  updateAnswer: PropTypes.func,
  validateQuestionnaire: PropTypes.func,
  disabled: PropTypes.bool,
  answerItem: PropTypes.object,
};
